module.exports = __webpack_public_path__ + "f7ee020c35edc5ac17f38d455fb96320.png";


//////////////////
// WEBPACK FOOTER
// ./assets/icons/closeIcon.png
// module id = 8ApR
// module chunks = 17